export function localidadesInRequest(params = {}) {
  return {
    type: '@localidade/LOCALIDADES_IN_REQUEST',
    payload: { params },
  };
}

export function findLocalidade(idlocalidade) {
  return {
    type: '@localidade/FIND_LOCALIDADE',
    payload: { idlocalidade },
  };
}

export function failedRequest() {
  return {
    type: '@localidade/FAILED_REQUEST',
  };
}

export function deleteLocalidade(idlocalidade, params) {
  return {
    type: '@localidade/DELETE_LOCALIDADE',
    payload: { idlocalidade, params },
  };
}

export function updateLocalidade(idlocalidade, params) {
  return {
    type: '@localidade/UPDATE_LOCALIDADE',
    payload: { idlocalidade, params },
  };
}

export function storeLocalidade(localidade, params) {
  return {
    type: '@localidade/STORE_LOCALIDADE',
    payload: { localidade, params },
  };
}

export function successInRequest(
  localidades,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@localidade/SUCCESS_IN_REQUEST',
    payload: { localidades, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(localidade) {
  return {
    type: '@localidade/SUCCESS_REQUEST',
    payload: { localidade },
  };
}

export function successRemove(params) {
  return {
    type: '@localidade/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@localidade/RECORD_FILTERING',
    payload: { params },
  };
}
